import React, { useState } from "react";
import { usePaystack } from "../hooks/usePaystack";
import { useAuth } from "../contexts/AuthContext";
import { useTokens } from "../hooks/useTokens";
import { supabase } from "../supabase";

const TOKEN_PACKAGES = [
  { tokens: 750, price: 75, credits: 750, scans: 3 },
  { tokens: 2500, price: 150, credits: 2500, scans: 10 },
  { tokens: 12500, price: 450, credits: 12500, scans: 50 },
];

const TokenPurchaseModal = ({ isOpen, onClose, onSuccess }) => {
  const { user } = useAuth();
  const { addTokens } = useTokens();
  const { initializePayment, loading, error } = usePaystack();
  const [selectedPackage, setSelectedPackage] = useState(TOKEN_PACKAGES[0]);

  const handlePurchase = async () => {
    if (!user) return;

    const onPaymentSuccess = async (response, tokenAmount) => {
      try {
        // Add tokens to user account using the useTokens hook
        await addTokens(selectedPackage.tokens);

        // Show success message
        alert(`Successfully purchased ${selectedPackage.scans} CV scans!`);
        onSuccess?.();
        onClose();
      } catch (err) {
        console.error("Error processing payment success:", err);
        alert("Payment successful but there was an error updating your account. Please contact support.");
      }
    };

    const onPaymentError = (error) => {
      console.error("Payment error:", error);
      alert(`Payment failed: ${error}`);
    };

    initializePayment(
      selectedPackage.price,
      selectedPackage.tokens,
      onPaymentSuccess,
      onPaymentError
    );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-black">Purchase CV Scans</h2>

        <div className="grid grid-cols-1 gap-4 mb-6">
          {TOKEN_PACKAGES.map((pkg) => (
            <button
              key={pkg.tokens}
              className={`p-4 rounded-lg border-2 cursor-pointer ${
                selectedPackage.tokens === pkg.tokens
                  ? "border-black bg-gray-50"
                  : "border-gray-200 hover:border-black"
              }`}
              onClick={() => setSelectedPackage(pkg)}
            >
              <div className="font-bold text-lg text-black">
                {pkg.scans} scans
              </div>
              <div className="text-black">R{pkg.price}</div>
              <div className="text-sm text-gray-600">
                {pkg.credits} CV tokens
              </div>
            </button>
          ))}
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}

        <div className="flex justify-end gap-4">
          <button
            className="px-4 py-2 text-black cursor-pointer"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50 cursor-pointer"
            onClick={handlePurchase}
            disabled={loading}
          >
            {loading ? "Processing..." : "Purchase"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenPurchaseModal; 